import { defineFcm } from '../shared/factory';

export const FCM_MEMBERSHIP_CONTACT_EMAIL = defineFcm('membership_contact_email')
	.asString()
	.withDefault('help@change.org')
	.toConfig({
		owner: 'squad-site-platform-payments',
		scope: 'corgi-front-end',
		context: 'PPMU Thank You page',
		description: 'Contact email to put in the generated receipt. Defaults to help@change.org.',
	});
